  import React, { useState } from "react";
import Home from "../Home";
import * as image from "../../resources/images";
import { SelectPicker, Rating } from "../../utils/Packages";
import RoundProgress from "../controls/RoundProgress";
import Link from "antd/es/typography/Link";
import CourseRatings from "../controls/CourseRatings";
import { CourseCard } from "../dimensions/activity";

const CourseStaticPage = () => {
  return (
    <div>
      <Home>
      <div className="d-flex flex-wrap SpecialLeftpanel w-100">
      <div className="d-flex w-100 align-items-start overflow-visible">
          <div className="LeftbarPannel p-0" id="">
                     <div class="form-title mt-0 mb-0 Enrollcoursetitle heading p-0">
                     <div class="tabgrid m-0 socialgridtab flex">
                     <ul>
                     <li class="tabs"><img src={image.LessonIcon1} /> Lessons</li>
                     <li class="tabs "><img src="/static/media/growthSurveyIcon.5f2c2b23293825f10f3c.png" alt="" /> Growth Survey</li>
                     <li class="tabs active-tabs"><img src={image.module_challenge} alt="module_challenge" /> Challenge</li>
                     <li class="tabs "><img src="/static/media/wavehand.91fc2cb19269b40e14ba.png" alt="" /> Characters</li>
                     <li className='tabs learner_pLan_dropdown moreTabs' id="moreTabs">
										<span
										   	aria-haspopup='true'
										  	aria-expanded='false'
										  	id='MoreItemsTeb'
										  	data-toggle='dropdown' className="w-100 flexone">
										  	<img src={image.moreitems} alt='' style={{ width: "24px" }} />
										  	<span className='ms-1'>More</span>
										  	<i className='fa-regular fa-angle-down ms-2 moreTabsDownIcon'></i>
										</span>
										<ul
											className='dropdown-menu dropdown-menu-end lPDropdwnList tabingmenuDropdown'
											aria-labelledby='MoreItemsTeb'>
											
												<li
													className={`tabs`}
												>
													<img src={image.SceneRefrence} alt='' /> References
												</li>
										
												
														<li
															className={`tabs `}
															>
															<img src={image.peronalitytypeicon} alt='' />{" "}
															Personality Type
														</li>

														<li
															className={`tabs multiQuiz
																 active-tabs
																w-100"
																`}
														>
															<img src={image.multipleintellQuiz} alt='' /> Multiple
															Intelligences
														</li>
										</ul>
									   </li>
                     
                     </ul>
                     <div class="LRSlidearrow CourseSlidearrrow">
                     <span class="pointer "><i class="fa-light fa-chevron-left"></i></span>
                     <span class="ScenePagination">
                     <strong class="mr-2 ">6</strong>of<strong class="ml-2">8</strong>
                     </span>
                     <span class="pointer "><i class="fa-light fa-chevron-right"></i></span>
                     </div>
                     <div class="jumptopagescene dropdownlistmodl">
                     <span class="Activitymenubar pointer jumptodropicn " aria-haspopup="true" aria-expanded="false" id="barlistsubdropdown" data-toggle="dropdown">
                     <i class="fa-regular fa-angle-down"></i></span>
                     </div>
                     </div>
                    
                     </div>
                     
                    <div className='CourseCardWrapper fullHeight100'>
                    
                      <div className="Course_height">
                      <div class="gridSection">
                      <div className="planprogresdash flex align-items-start">
                      <div class="planprogress_list w-50 p-0">
                      {/* <div className="staire_map">
                      <ul>
                      <li>  <div className="">
                                 Start
                               </div>
                                 <div className="character">
                            <img src={image.character_plan} />
                          </div>
                               </li>
                      <li className="">
                       <div className="module_num">
                      <span className="modu_numtxt">M1</span>
                                      <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p>
                                {" "}
                                <img src={image.Scorecardicon} alt='' />
                                Scorecard
                              </p>
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.rewardimg} alt='' />
                                Reward
                              </p>
                                       </li>
                                       <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.money_bag} alt='' />
                                800
                              </p>
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                       </div>
                      <div className="green_bg"></div>
                      </li>
                      <li> 
                      <div className="module_num">M2
                      <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                                <li className={`rewardDrpDwnd  `}>
                                        <p>
                                {" "}
                                <img src={image.Scorecardicon} alt='' />
                                Scorecard
                              </p>
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.rewardimg} alt='' />
                                Reward
                              </p>
                                       </li>
                                       <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.money_bag} alt='' />
                                800
                              </p>
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                      </div></li>
                      <li> <div className="module_num">M3
                      <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                                  <li className={`rewardDrpDwnd  `}>
                                        <p>
                                {" "}
                                <img src={image.Scorecardicon} alt='' />
                                Scorecard
                              </p>
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.rewardimg} alt='' />
                                Reward
                              </p>
                                       </li>
                                       <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.money_bag} alt='' />
                                800
                              </p>
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                      </div></li>
                      <li> <div className="module_num">M4
                      <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                                <li className={`rewardDrpDwnd  `}>
                                        <p>
                                {" "}
                                <img src={image.Scorecardicon} alt='' />
                                Scorecard
                              </p>
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.rewardimg} alt='' />
                                Reward
                              </p>
                                       </li>
                                       <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.money_bag} alt='' />
                                800
                              </p>
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                      </div></li>
                     </ul>
                    <ul>
                      <li>  <div className="course_indx">
                                 C1
                                 <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                      
                                        <i class="fa-solid fa-angle-down ps-1 fa-sm"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                              <li className={`rewardDrpDwnd  `}>
                                        <p>
                                {" "}
                                <img src={image.Scorecardicon} alt='' />
                                Scorecard
                              </p>
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.rewardimg} alt='' />
                                Reward
                              </p>
                                       </li>
                                       <li className={`rewardDrpDwnd  `}>
                                        <p className='pointer'>
                                <img src={image.money_bag} alt='' />
                                800
                              </p>
                                       </li>
                                        
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.mortarboard} />
                                           Go to course
                                         </li>
      
                                    </ul>
                                 <span className="poitbag_score">
                            <img src={image.money_bag} />
                            <span>880</span>
                          </span>
                               </div></li>
                               <li> <div className="module_num">M1</div></li>
                               <li> <div className="module_num">M2</div></li>
                      <li> <div className="module_num">M3</div></li>
                      <li> <div className="module_num">M4</div></li>
                     </ul>
                     <ul>
                      <li>  <div className="course_indx">
                                 C2
                                 <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa-solid fa-angle-down ps-1 fa-sm"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                                 <span className="poitbag_score">
                            <img src={image.money_bag} />
                            <span>880</span>
                          </span>
                               </div></li>
                               <li> <div className="module_num">M1</div></li>
                               <li> <div className="module_num">M2</div></li>
                      <li> <div className="module_num">M3</div></li>
                      <li> <div className="module_num">M4</div></li>
                     </ul>
                     <ul>
                      <li>  <div className="course_indx">
                                 C3
                                 <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                     <i class="fa-solid fa-angle-down ps-1 fa-sm"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                                 <span className="poitbag_score">
                            <img src={image.money_bag} />
                            <span>880</span>
                          </span>
                               </div></li>
                               <li> <div className="module_num">M1</div></li>
                               <li> <div className="module_num">M2</div></li>
                      <li> <div className="module_num">M3</div></li>
                      <li> <div className="module_num">M4</div></li>
                     </ul>
                     <ul>
                      <li>  <div className="course_indx">
                                 C4
                                 <span className="plan_end_flag">
                            <img src={image.right_fliag_stand} />
                          </span>
                                 <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                      <i class="fa-solid fa-angle-down ps-1 fa-sm"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                                 <span className="poitbag_score">
                            <img src={image.money_bag} />
                            <span>880</span>
                          </span>
                               </div></li>
                   
                     </ul>
                      </div> */}
                      <table class="module_completed_ badgesdetails_card d-block px-3 py-2">
                      <tr>
                      <td>
                      <div class="clbcarddtl">
                      <div class="lbuserdtl">
                      <div class="lbuserimage text-center">
                      <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Mindfulness+Champion.png" alt=""/>
                      </div>
                      <div class="lbuserName pb-2">
                      <h4 className="text-center mb-3">Mindfulness Champion</h4>
                       
                       <p>I’m a Mindfulness Champion! Stress? Distractions?
                        Not a problem—I stay present and focused!</p>
                        <p>You’ve conquered distractions 
                          and mastered the art of staying present! Whether facing a quiz, a tough conversation,
                          or daily challenges, you stay calm, aware, and in control.</p>
                         </div>
                         </div>
                         </div>
                         </td>
                         </tr>
                         </table>
      
                         {/* <ul>
                          <li>
                       
                          <div className="course_track">
                          <div className="character">
                            <img src={image.character_plan} />
                          </div>
                          <ul className="module_list">
                               <li> 
                               <div className="planprog_title_text">
                                 Start
                               </div>
                               </li>
                              <li className="green_bg">M1</li>
                              <li>M2</li>
                              <li>M3</li>
                              <li>M4</li>
                             </ul>
                         <div className="track_progress track_progressc1 flex">
                            <span className="couprog_">50%</span>
                             <span className="module">M1</span> 
                           
                           </div>
                           
                          </div>
                        
                          </li>
                          <li>
                          <div className="planprog_title_text learner_pLan_dropdown">
                          <span className="poitbag_score">
                            <img src={image.money_bag} />
                            <span>880</span>
                          </span>
                          C1
                          <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.money_bag} />
                                          800: Earn Point 
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.money_bag} />
                                          800: Earn Point 
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                          </div>
                          <div className="course_track">
                          <ul className="module_list">
                              <li className="">M1</li>
                              <li>M2</li>
                              <li>M3</li>
                              <li>M4</li>
                             </ul>
                           <div className="track_progress"></div>
                          </div>
                          </li>
                          <li>
                          <div className="planprog_title_text learner_pLan_dropdown">
                          <span className="poitbag_score">
                            <img src={image.money_bag} />
                           
                          </span>
                          C2
                          <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                          </div>
                          <div className="course_track">
                            <div className="track_progress"></div> 
                           <ul className="module_list">
                              <li className="">M1</li>
                              <li>M2</li>
                              <li>M3</li>
                              <li>M4</li>
                             </ul>
                          </div>
                          </li>
                          <li>
                          <div className="planprog_title_text learner_pLan_dropdown">
                          <span className="poitbag_score">
                            <img src={image.money_bag} />
                           
                          </span>
                          C3
                          <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                          </div>
                          <div className="course_track">
                            <div className="track_progress"></div>
                           <ul className="module_list">
                              <li className="">M1</li>
                              <li>M2</li>
                              <li>M3</li>
                              <li>M4</li>
                             </ul>
                          </div>
                          </li>
                          <li>
                          <div className="planprog_title_text learner_pLan_dropdown">C4
                          <span className="plan_end_flag">
                            <img src={image.intrest} />
                          </span>
                          <span className="poitbag_score">
                            <img src={image.money_bag} />
                       
                          </span>
                          <span 		aria-haspopup='true'
                                        aria-expanded='false'
                                        className=''
                                        id='Parenttools'
                                        data-toggle='dropdown'>
                                        <i class="fa fa-angle-down ps-1 fa-sm" aria-hidden="true"></i>
                                        </span>
                                        <ul	className='dropdown-menu dropdown-menu-end course_dropdwn'
                                          aria-labelledby='Parenttools'>
                                        <li className={`rewardDrpDwnd  `}>
                                         <img src={image.gensettings} />
                                           Parent Tools
                                        </li>
                                        <li className={`rewardDrpDwnd  `}>
                                        <img src={image.Electiclistiocn} />
                                           Learner Center
                                       </li>
                                         <li className={`rewardDrpDwnd  `}>
                                         <img src={image.Seriesicon} />
                                           Go to Lesson
                                         </li>
      
                                    </ul>
                          </div></li>
                        </ul>   */}
                      </div>
                       <div className="module_objective w-50 p-0">
                      <div class="plans_contents_">
                      <div className="pt-3 px-3">
                      <h3 class="mb-2">
                       <span class="_module_name">C1</span> Communication Foundations</h3>
                      <h3 class="mb-2">
                       <span class="_module_name">M1</span>Effective Communication Essentials</h3>
                      </div>
                     
                      <div class="tabgrid mt-3">
                      <ul class="objectibe_module_list flex">
                         <li class=" pointer tabs w-25 justify-content-center">M1</li>
                         <li class=" pointer tabs w-25 justify-content-center">M2</li>
                         <li class=" pointer tabs w-25 justify-content-center">M3</li>
                         <li class="active-tabs pointer tabs w-25 justify-content-center">M4</li>
                      </ul>
                      </div>
                      <div className="px-3">
                         <h4 class="mb-3 flex">Module Objectives 
                         <span class="Score_points"><span class="earnnoCoin">0</span>
                         <img src={image.money_bag} alt="pointbag" />
                         </span>
                         </h4>
                         <ul>
                         <li class="d-flex">
                         <div class="obj_prog_ress">
                         <span class="Progresslistitem m-0">
                         <span class="diemensionalProgress progressbar1" style={{maxWidth: "0%" ,background: "rgb(32, 201, 151)"}}></span><span class="percentage_marker" style={{left:"0%"}}>0<sub>%</sub></span></span></div><span class="">Understand the principles of effective communication, including active listening and empathy.</span></li><li class="d-flex"><div class="obj_prog_ress"><span class="Progresslistitem m-0"><span class="diemensionalProgress progressbar1" style={{maxWidth: "0%", background: "rgb(32, 201, 151)"}}></span><span class="percentage_marker" style={{left: "0%;"}}>0<sub>%</sub></span></span></div><span class="">Recognize the role of nonverbal cues, tone, and body language in enhancing communication.</span></li><li class="d-flex"><div class="obj_prog_ress"><span class="Progresslistitem m-0"><span class="diemensionalProgress progressbar1" style={{maxWidth: "0%;" ,background: "rgb(32, 201, 151);"}}></span><span class="percentage_marker">0<sub>%</sub></span></span></div><span class="">Adapt communication styles for different audiences and settings to improve understanding.</span></li><li class="d-flex"><div class="obj_prog_ress"><span class="Progresslistitem m-0"><span class="diemensionalProgress progressbar1"></span><span class="percentage_marker">0<sub>%</sub></span></span></div><span class="">Set personal communication goals to foster continuous growth and improve interpersonal skills.</span></li><li class="d-flex"><div class="obj_prog_ress"><span class="Progresslistitem m-0"><span class="diemensionalProgress progressbar1" ></span><span class="percentage_marker">0<sub>%</sub></span></span></div><span class="">Reflect on past communication experiences to identify strengths and areas for improvement.</span></li></ul></div>
                      </div>
                       </div> 
                       </div> 
             {/*    <div className="leader_board_contnr">
       <h3 className="mb-3  pl-3">LeaderBoard</h3>   */}
      {/* <div className="student_leader_board flex align-items-start">
      
        <table cellPadding="0" cellSpacing="0" width="100%" className="studentleaderboardtbl">
            <tr>
            <th>
              <span className="student_count"><strong>Rank</strong></span>
              </th>
              <th>
              <span className="stud_name">
                <strong className="Avtar_user_name"> <img src={image.myAvtar_icon} className="mr-2" alt="" /></strong>
                 Name
              </span>
              </th>
              <th><span>Total</span></th>
              <th> <span>Lessons</span></th>
              <th> <span>MCs</span></th>
              <th> <span>KCs</span></th>
              <th> <span>MEs</span></th>
              <th><span>Streak</span></th>
              <th> <span>Next Goal</span></th>
              <th> <span>Achievements</span></th>
              <th> <span>Message</span></th>
               
              
          
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>1</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>2</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>3</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>4</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>5</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>6</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
            <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>7</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
              </tr>
             <tr>
              <td className="student_count"><strong>1</strong></td>
              <td className="stud_name">
              <strong className="Avtar_user_name">  <img src="https://bloomster.s3.us-east-1.amazonaws.com/avatar/3_right.png" className="mr-2" alt="" /></strong>
                 L1 Avatar
              </td>
                <td>520</td>
                <td>120</td>
                <td>90</td>
                <td>150</td>
                <td>160</td>
                <td>(5-day)</td>
                <td>+75 pts to Rank 1</td>
                <td>(Finished 1 Full Course)</td>
                <td>"So close! Just 75 pts to Rank 1!"</td>
                <td>
                  <table className="leade_bord_detailcard">
                    <tr>
                    <td>
                    <div className="clbcarddtl">
                      <div className="lbuserdtl flexone">
                        <div className="lbuserimage">
                          <img src={image.Avtar10} />
                        </div>
                        <div className="lbuserName">
                          <h4>Avatar L1</h4>
                          <p><i>"You're leading the way! 🚀"</i></p>
                        </div>
                      </div>
                      <ul>
                        <li><span>Rank</span>1</li>
                        <li><span>Total</span>520</li>
                       <li> <span>Lessons</span>120</li>
                       <li> <span>MCs</span>90</li>
                       <li> <span>KCs</span>150</li>
                        <li> <span>MEs</span>160</li>
                        <li><span>Streak</span>5-day</li>
                         <li> <span>Next Goal</span>+75 pts to Rank 1</li>
                          <li> <span>img Achievements</span> 1 Full Course</li>
                         
                      </ul>
                    </div>
                    </td>
                    </tr>
                  </table>
                </td>
            </tr>
          </table>
      </div> 
      </div>*/}
                      
      
                      </div>
                      
                      </div>
                       </div> 
                       <div class="LeftPanelFooter input-group full-Width-group basic_details_form pagebuttonStrip ">
                       <div class="form-group BDsubmitbutton d-flex justify-content-right align-items-center m-0 ">
                       <div class="">
                       {/* <button class="btn-blue btn-login d-block float-right w-auto" disabled="">
                       <span> <i class="fa-solid fa-arrow-left m-0 mr-2"></i></span>Back</button>
                       </div>
                       <div class="w-100">
                       <button class="btn-blue btn-login d-block float-right w-auto">Next<span> 
                       <i class="fa-solid fa-arrow-right m-0 ml-2"></i></span>
                       </button> */}
                       </div>
                       </div>
                       </div>
                       </div>
                            <div className="RightbarPannel p-0 rightpannelSticky newcoursecardpanel setuptwo_rPnl">
                                     <div className="heading p-0 border-0">
                                       <div class="form-title mt-0 mb-0 Enrollcoursetitle heading">
                                         <h2 data-toggle="collapse" class="m-0 pt-0 pb-1 w-100 flex justify-content-between ">
                                           <span> <img src={image.module_challenge} className='mr-2' alt="" />
                                             Module Challenge
                                             </span>
                                         </h2>
                                       </div>
                       
                                     </div>
                                     <div className="CourseCardWrapper fullHeight100">
                                     <div class="LessionDtlOverview m-0">
                                     <div class="d-flex align-items-start flex-wrap p-0">
                                     <div class="flex w-100 mb-3 align-items-start flex-wrap text-justify textcontentSidebar p-0">
                                     <p><div class="module_challenge_">
                                     <h4 class="mx-2 mb-3 mt-2">The School Recycling Plan</h4>
                                     <div class="helpvideosection pointer">
                                     <div class="challenge_story_vid mt-3 mb-3 position-relative">
                                     <img src="https://bloomster.s3.us-east-1.amazonaws.com/growth-plan/Resilient+Decision-Maker.jpg" alt="" />
                                     <img src={image.View_Video} alt="video_icon" className="view_video_plan border-0" />
                                     </div>
                                     </div>
                                     <div class="how_challenges_work mt-3 p-2">
                                     <h4>How the Challenge Works:</h4>
                                     <ul>
                                     <li>
                                     <img src={image.Capturevdfhfveh} />
                                          Use Root-Cause Analysis to uncover why recycling rates are low.</li>
                                     <li>
                                     <img src={image.Capturevdfhfveh} />
                                          Develop a creative solution using Design Thinking.</li>
                                     </ul>
                                     </div>
                                     </div>
                                     </p>
                                     </div>
                                     </div>
                                     </div>
                                    
                                   </div>
                       
                                   <div class="LeftPanelFooter input-group full-Width-group basic_details_form pagebuttonStrip ">
                                   <div class="form-group BDsubmitbutton d-flex justify-content-right align-items-center m-0 ">
                                   <div class="w-100">
                                        {/* <button class="btn-blue btn-login d-block float-right w-auto"><span> 
                                        <i class="fa-solid fa-arrow-left m-0 mr-2"></i></span>Back
                                        </button> */}
                                        </div>
                                  
                           </div>
                      </div>
                </div> 
      </div>
      </div>
      </Home>
    </div>
  )
}

export default CourseStaticPage
